import { AuthModel } from '../modules/auth/core/_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

/**
 * Retrieves stored authentication data from localStorage
 * Handles legacy auth_token format for backwards compatibility
 */
export const getStoredAuth = (): AuthModel | null => {
  try {
    const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    if (!lsValue) return null
    
    const auth: AuthModel = JSON.parse(lsValue)
    if (auth) {
      // Handle legacy auth_token format for backwards compatibility
      if (auth.auth_token && !auth.token) {
        auth.token = auth.auth_token
      }
      return auth
    }
  } catch (error) {
    console.error('Error parsing stored auth:', error)
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  }
  return null
}

/**
 * Stores authentication data in localStorage
 * Only stores tokens, not user data for security reasons
 */
export const setStoredAuth = (auth: AuthModel): void => {
  try {
    const lsValue = JSON.stringify({
      token: auth.token,
      laravel_token: auth.laravel_token,
      // Don't store user data in localStorage - will fetch from /auth/me
    })
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('Error saving auth to localStorage:', error)
  }
}

/**
 * Removes authentication data from localStorage
 */
export const removeStoredAuth = (): void => {
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
}

/**
 * Clears all authentication-related data from storage
 * Use with caution as this clears ALL localStorage and sessionStorage
 */
export const clearAllAuthData = (): void => {
  removeStoredAuth()
  localStorage.clear()
  sessionStorage.clear()
}

/**
 * Checks if there's any stored authentication data
 */
export const hasStoredAuth = (): boolean => {
  const storedAuth = getStoredAuth()
  return !!(storedAuth?.token || storedAuth?.laravel_token)
}
